import { DEFAULT_ASPECT_RATIO } from "../constants";

const DEFAULT_WIDTH = 960;
const SRCSET_WIDTHS = [480, 640, 960, 1280, 1920];

const isAspectRatioInCorrectFormat = (aspectRatio: string) =>
  /^[1-9]\d*:[1-9]\d*$/.test(aspectRatio);

type ImageUrlParams = {
  aspectRatio?: string;
  id: string | undefined;
  serviceId?: string;
  width?: number;
};

export const imageUrl = ({
  aspectRatio = DEFAULT_ASPECT_RATIO.LANDSCAPE,
  id,
  serviceId,
  width = DEFAULT_WIDTH
}: ImageUrlParams): string => {
  const idWithDefault = id || serviceId;
  if (!idWithDefault) return "";

  if (!isAspectRatioInCorrectFormat(aspectRatio)) {
    console.warn(`Ignored misformed aspect ratio: ${aspectRatio}`);
    aspectRatio = DEFAULT_ASPECT_RATIO.LANDSCAPE;
  }

  const transformations = [`ar_${aspectRatio}`, `w_${width}`];

  if (serviceId && idWithDefault !== serviceId) {
    transformations.push(`default_${serviceId}`);
  }

  return `${__IMAGE_CDN_URL}/${transformations.join()}/${idWithDefault}`;
};

type ImageSrcSetParams = {
  aspectRatio?: string;
  id: string;
  serviceId?: string;
};

export const imageSrcSet = (params: ImageSrcSetParams): string =>
  SRCSET_WIDTHS.map(
    width => `${imageUrl({ ...params, width })} ${width}w`
  ).join(", ");
